module.exports = __webpack_public_path__ + "assets/images/d4b133b0906699ca3749d130f5c5007a.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/directv-logo.png
// module id = 824
// module chunks = 0